import Header from './components/Header';
import HeroSection from './components/HeroSection';
import {
  UpdatesSection,
  FeaturesSection,
  AppSection,
  TopicsSection,
  MediaSection,
  AboutSection,
} from './components/SectionsGroup1';
import {
  FaqSection,
  CardsSection,
  IndexSection,
  CommentsSection,
  CarouselSection,
  ContactSection,
  RankingSection,
} from './components/SectionsGroup2';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <UpdatesSection />
        <FeaturesSection />
        <AppSection />
        <TopicsSection />
        <MediaSection />
        <AboutSection />
        <FaqSection />
        <CardsSection />
        <IndexSection />
        <CommentsSection />
        <CarouselSection />
        <ContactSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}